import { useAuth } from 'react-oidc-context';
import { getUserDisplayName } from '../services/UserDisplayService';

interface UseUserDisplayReturn {
  displayName: string;
  isAuthenticated: boolean;
}

export const useUserDisplay = (): UseUserDisplayReturn => {
  const auth = useAuth();

  const userProfile = auth.user?.profile as any | null;
  const displayName = getUserDisplayName(userProfile);

  return {
    displayName,
    isAuthenticated: !!auth.user
  };
};